import { Injectable } from '@angular/core';
import { WebViewerInstance } from '@pdftron/webviewer';
@Injectable({
	providedIn: 'root'
})
export class FileMergeService {
	public wvInstance: WebViewerInstance;
	constructor() { }

	get webViewerInstance(): WebViewerInstance {
		return this.wvInstance;
	}
	set webViewerInstance(val: WebViewerInstance) {
		this.wvInstance=val;
	}


	public async mergeDocumentsAndDownload(byteStreamArray: any, documentType: string) {
		try {
			const { PDFNet } = await this.webViewerInstance?.Core;
			await PDFNet.initialize();

			await PDFNet.startDeallocateStack();
			const newDoc = await PDFNet.PDFDoc.create();

			void newDoc.initSecurityHandler();
			void newDoc.lock();
			let index = 1;
			for (const itemStream of byteStreamArray) {
				const currDoc = await PDFNet.PDFDoc.createFromBuffer(itemStream);
				await currDoc.getPageCount().then(async (currDocPageCount: any) => {
					await newDoc.insertPages(index, currDoc, 1, currDocPageCount, PDFNet.PDFDoc.InsertFlag.e_none);
					index += currDocPageCount;
				});
			}

			const combinedBuffer = await newDoc.saveMemoryBuffer(PDFNet.SDFDoc.SaveOptions.e_linearized);
			const blob = new Blob([combinedBuffer], { type: 'application/pdf' });
			await PDFNet.endDeallocateStack();
			const downloadUrl= URL.createObjectURL(blob);
			const downloadLink = document.createElement('a');
			downloadLink.href = downloadUrl;
			const todaysDate = new Date().toISOString().slice(0,10);
			downloadLink.download = `${documentType}-${todaysDate}.pdf`;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			downloadLink.remove();
		} catch (error) {
			console.error('Error merging documents:', error);
		}
	}
}
